<template>
    <div class="wrap">
        <navbar :transparent="isTransparent" activeTo="ContactUs"></navbar>
        <div class="contact_banenr"></div>
        <div class="contact_main">
            <div class="contact_main_title">
                <p>{{$t('contact_us_mainpage_title')}}</p>
            </div>
            <div class="contact_main_group">
                <div class="contact_item1">
                    <!--<div class="tabs"  style="position: relative;">-->
                        <!--<div class="tab" @mouseover="toggle" @mouseout="toggle_hide" @click="toggledouble">-->
                            <!--<a>{{area}}<Icon type="chevron-down" style="margin-left: 10px;"></Icon></a>-->
                            <div class="tab_content">
                                <ul class="tab_choose">
                                    <li  @click="toggleTab('secont',$event,2,2)"><div class="tab-box" :style="{borderTopColor:contactId=='2'?'#0084ff':'#fff'}"></div>{{$t('contact_us_company_hongkong')}}</li>
                                    <li  @click="toggleTab('first',$event,1,1)"><div class="tab-box" :style="{borderTopColor:contactId=='1'?'#0084ff':'#fff'}"></div>{{$t('contact_us_company_guangzhou')}}</li>
                                    <li  @click="toggleTab('zero',$event,0,7)"><div class="tab-box" :style="{borderTopColor:contactId=='7'?'#0084ff':'#fff'}"></div>{{$t('contact_us_company_taiwan')}}</li>
                                    <li  @click="toggleTab('third',$event,3,3)"><div class="tab-box" :style="{borderTopColor:contactId=='3'?'#0084ff':'#fff'}"></div>{{$t('contact_us_company_malaysia')}}</li>
                                    <li  @click="toggleTab('fourth',$event,4,4)"><div class="tab-box" :style="{borderTopColor:contactId=='4'?'#0084ff':'#fff'}"></div>{{$t('contact_us_company_thailand')}}</li>
                                    <li  @click="toggleTab('fifth',$event,5,5)"><div class="tab-box" :style="{borderTopColor:contactId=='5'?'#0084ff':'#fff'}"></div>{{$t('contact_us_company_singapore')}}</li>
                                    <li  @click="toggleTab('sixth',$event,6,6)"><div class="tab-box" :style="{borderTopColor:contactId=='6'?'#0084ff':'#fff'}"></div>{{$t('contact_us_company_japan')}}</li>
                                </ul>
                            </div>
                        <!--</div>-->
                    <!--</div>-->
                    <!--<div class="tab_choose_address">-->
                        <!--{{$t('add_address_address')}}: <br> {{address}}-->
                        <!--<p>{{phone}}</p>-->
                        <!--<p>{{email}}</p>-->
                    <!--</div>-->
                    <div class="contact_main_group">
                        <div class="contact_main_item">
                            <div class="contact_main_header">
                                <img src="../../assets/icon50_call.png" width="40">
                            </div>
                            <div class="contact_main_body1">
                                <p class="contact_main_way">{{$t('contact_way1')}}:</p>
                            </div>
                            <div class="contact_main_body2">
                                <p class="contact_main_answer">+852 2473 8888</p>
                            </div>
                        </div>
                    </div>
                    <div class="contact_main_group">
                        <div class="contact_main_item">
                            <div class="contact_main_header">
                                <img src="../../assets/004-whatsapp.png" width="40">
                            </div>
                            <div class="contact_main_body1">
                                <p class="contact_main_way">WhatsApp:</p>
                            </div>
                            <div class="contact_main_body2">
                                <p class="contact_main_answer">+4474 5204 6699</p>
                            </div>
                        </div>
                    </div>
                    <div class="contact_main_group">
                        <div class="contact_main_item">
                            <div class="contact_main_header">
                                <img src="../../assets/wechat.png" width="40">
                            </div>
                            <div class="contact_main_body1">
                                <p class="contact_main_way">{{$t('contact_way2')}}:</p>
                            </div>
                            <div class="contact_main_body2">
                                <p class="contact_main_answer">IFREEGROUP</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="map_showpace">
                    <first :is="currentTab" keep-alive></first>
                </div>
            </div>
        </div>

        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>
<script>
    import navbar from '../Common/Navbar.vue'
    import first from './map/first.vue'
    import secont from './map/secont.vue'
    import third from './map/third.vue'
    import fourth from './map/fourth.vue'
    import fifth from './map/fifth.vue'
    import sixth from './map/sixth.vue'
    import zero from './map/zero.vue'

    export default {
        data () {
            return {
                isShow: false,
                isTransparent: false,
                address:this.$t('contact_us_company_hongkong_address'),
                area: this.$t('contact_us_company_hongkong'),
                currentTab: 'secont',  // currentTab用于标识当前触发的子组件
                phone:this.$t('contact_us_company_hongkong_address1'),
                email:this.$t('contact_us_company_hongkong_address2'),
                contactId:2,
            }
        },
        components: {
            navbar,
            first,
            secont,
            third,
            fourth,
            fifth,
            sixth,
            zero
        },
        methods: {
            toggleTab: function (tab,event,id,store_id) {
                this.toggle_hide()
                this.currentTab = tab  // tab为当前触发标签页的组件名
                var el = event.currentTarget;
                this.area = el.innerHTML
                this.contactId = store_id;
                console.log(this.contactId)
                //接接口
                let module = 'index.php/storedetail'
                let data = {}
                data.lang = this.$i18n.locale
                data.id = store_id
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        if (parseInt(response.data.code) === 2000) {
                            console.log(response.data)
                            this.address = response.data.data.address
                            this.phone = response.data.data.phone
                            this.email = response.data.data.email
                        }
                    }.bind(this))
            },
            toggle: function () {
                this.isShow = true
            },
            toggle_hide(){
                this.isShow = false
            },
            toggledouble(){
                this.isShow =! this.isShow
            }
        }
    }
</script>
<style lang="scss">
    @import "../../scss/_contact.scss";
</style>



// WEBPACK FOOTER //
// ContactUs.vue?517a2cc5